export default __webpack_public_path__ + "assets/uv-index.90f496cc.svg";